import React from 'react';

import { useSnackbar } from 'notistack';

import useBlocRef from '../../utils/useBlocRef.hook';
import SendInvite from '../sendInvite/SendInvite';

const inviteFields = [
  { disabled: true, label: 'Patient Name', name: 'name', type: 'text' },
  { disabled: true, label: 'Telephone', name: 'phoneNumber', type: 'text' },
  { disabled: true, label: 'Patient Email Address', name: 'email', type: 'text' },
  { disabled: true, label: 'Patient Date of Birth', name: 'dateOfBirth', type: 'date' },
];

export default ({ patient, workspaceId }) => {
  const blocRef = useBlocRef('resendInviteBloc');
  const { enqueueSnackbar } = useSnackbar();

  const onInvite = async (data) => {
    try {
      await blocRef.current.reInvitePatient({
        ...data,
        userId: patient.id,
        workspaceId,
      });
    } catch (error) {
      enqueueSnackbar(error.message, { autoHideDuration: 10000, variant: 'error' });
    }
  };

  return (
    <SendInvite
      fields={inviteFields}
      buttonText="Resend Invite"
      onInvite={onInvite}
      user={patient}
      title="Resend Invite"
      hint="If a user has not accepted or accessed their account you can resend the invite from this screen."
      note="Note that an invitation link will be sent to the patient email address once submitted."
      isSubmitting$={blocRef.current.isReInvitingPatient$}
    />
  );
};
